import React, { useContext, useEffect, useState } from 'react'
import { GVarState } from '../StoreState/Gstate';
import "./DropDownFloor.css";

function DropDownFloor({ mobile }) {
  let g = useContext(GVarState);
  const [SelectFirst, setSelectFirst] = useState(null)

  useEffect(() => {
    if (g?.FloorImg && g?.CurrentFloor>=0) {
      console.log(g?.FloorImg[g?.CurrentFloor].ShortName, "krishnak");
      setSelectFirst(g?.FloorImg[g?.CurrentFloor].ShortName)
    }
  }, [g.CurrentFloor, g.FloorImg])
  function openDrop() {
    let x = document.querySelectorAll('.Dropmenu')
    for (let index = 0; index < x.length; index++) {
      const element = x[index];
      element.style.padding = "10px 15px"
      element.style.height = "auto"
      element.style.width = "auto"

    }



  }
  function doAction(d, i) {
    setSelectFirst(d.ShortName)
    g.setCurrentFloor(i)
    let x = document.querySelectorAll('.Dropmenu')
    for (let index = 0; index < x.length; index++) {
      const element = x[index];
      element.style.padding = "0px"
      element.style.height = 0 + "px"
      element.style.width = 0 + "px"

    }
  }
  return (
    <>
      {mobile == true ?
        <>
          <div className="Drop DropMo" onClick={openDrop} style={{ top: g.StartAndEndPart ? "175px" : "120px" }}>
            {<h6>{SelectFirst || ''}</h6>}

          </div>
          <div className="Dropmenu DropMo" style={{ top: g.StartAndEndPart ? "175px" : "120px" }} >
            {g.FloorImg?.map((d, i) => (
              <span key={i} onClick={() => doAction(d, i)} >
                <p >{d.FloorName}</p>
                <b>{d.ShortName}</b>
              </span>
            ))}
          </div>
        </>
        : <>
          <div className="Drop" onClick={openDrop}>
            {/* {SelectFirst && <h6  >{SelectFirst.split(" ")[0][0] + (SelectFirst.split(" ")[1] ? SelectFirst.split(" ")[1][0] : "")}</h6>} */}
            {<h6>{SelectFirst || ''}</h6>}
          </div>
          <div className="Dropmenu " >
            {g.FloorImg?.map((d, i) => (
              <span key={i} onClick={() => doAction(d, i)} >
                <p >{d.FloorName}</p>
                <b>{d.ShortName}</b>
              </span>
            ))}
          </div>
          <div className='zoomin flex items-center justify-center' style={{ zIndex: 10001 }} onClick={(e) => {
            let xx = document.querySelector("canvas")
            let clickEvent = new WheelEvent('wheel', {
              deltaY: -100000,
              bubbles: true,
            });
            xx.dispatchEvent(clickEvent)
          }}><span>+</span></div>
          <div className='zoomout flex items-center justify-center' style={{ zIndex: 10001 }} onClick={(e) => {
            let xx = document.querySelector("canvas")
            let clickEvent = new WheelEvent('wheel', {
              deltaY: 10.0,
              bubbles: true,
            });
            xx.dispatchEvent(clickEvent)
          }}><span>-</span></div>
        </>
      }


    </>
  );
}

export default DropDownFloor